/**
 * accountFacts.js — what the page shows about an account's kind, and the refusals that come with it.
 *
 * An experience account (the portal's docs/ADMIN-API.md) is a player account with an end date that
 * keeps its sessions on the computer: the portal answers every request of it that would store
 * something with 403 { error: 'local_only' }.
 */

/** "12 Nov", or "12 Nov 2027" in another year. */
export function fmtDay(ms, now = Date.now()) {
    if (!Number.isFinite(ms)) return '';
    const d = new Date(ms);
    const sameYear = d.getFullYear() === new Date(now).getFullYear();
    return d.toLocaleDateString([], sameYear ? { day: 'numeric', month: 'short' } : { day: 'numeric', month: 'short', year: 'numeric' });
}

export const isExperience = (user) => user?.kind === 'experience';

/** "Experience · ends 12 Nov" (or "Experience" while the end is not known yet). */
export function experienceLabel(endsAt) {
    return Number.isFinite(endsAt) ? `Experience · ends ${fmtDay(endsAt)}` : 'Experience';
}

export const LOCAL_ONLY_TEXT = 'Not available for an experience account.';

/** A refused request's text for the user: local_only plainly, else the server's message or error. */
export function serverErrorText(body, fallback = '') {
    if (body && body.error === 'local_only') return LOCAL_ONLY_TEXT;
    if (body && typeof body.message === 'string' && body.message) return body.message;
    if (body && typeof body.error === 'string' && body.error) return body.error;
    return fallback;
}
